<template>
    <div>
        <b-modal id="modal-dl-comments" scrollable size="md" hide-footer :title="'COMMENTS FOR ('+item_comments_invoice_id+')'">
            <ItemComments :viewdata="{invoice_id: item_comments_invoice_id, itemid: item_comments_itemid, username: packet.userDetails.username}" />
        </b-modal>

        <div style="width: 100%;">
            <!-- <b-card no-body>
                <h5 style="z-index:100; font-family: courier; font-weight: bold; padding: 10px;">DELIVERIES LOADING</h5>
                <b-alert variant="secondary" show>
                    <div style="display: inline-block; margin: 3px;">
                        <div style="" v-if="packet.locsubs.length == 0">
                            <loading 
                            :active="true" 
                            :can-cancel="false" 
                            :is-full-page="false">
                            </loading>
                        </div>
                        <div v-else>
                            <div>LOADING LOCATION</div>
                            <b-form-select :options="locsubs" v-model="locsub" @change="get_dates">
                                <template #first>
                                    <b-form-select-option :value="null" disabled>-- Please pick a location --</b-form-select-option>
                                </template>
                            </b-form-select>
                        </div>
                    </div>

                    <div style="display: inline-block; margin: 3px;">

                        <div v-if="dates_being_loaded && this.locsub != null">

                            <loading 
                            :active="true" 
                            :can-cancel="false" 
                            :is-full-page="false">
                            </loading>
                        </div>

                        <div v-else>
                            <div v-if="dates.length == 0">
                                <b-alert show>NOTHING TO LOAD IN THIS LOCATION</b-alert>
                            </div>
                            <div v-else>
                                <div style="display: inline-block;">
                                    <div>SELECT DATE</div>
                                    <b-form-select :options="dates" @change="get_items_for_date"
                                    style="display: inline-block; width: 200px;"
                                    ></b-form-select>
                                </div>

                                <div style="display: inline-block;" v-if="items.length > 0">
                                    <div>DELIVERY TRUCK</div>
                                    <b-form-select :options="packet.trucks" v-model="allowed_truck"
                                     
                                     style="display: inline-block; width: 200px;"
                                    >
                                        <template #first>
                                            <b-form-select-option :value="null" >ALL</b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-alert>
            </b-card> -->

            <div>
                <b-alert variant="secondary" show>
                    <div style="display: block;">
                        <div style="display: inline-block; vertical-align: top;">
                            <div>SELECT YEAR</div>

                            <b-form-select size="lg" :options="years" v-model="year" style="width: 180px; font-size: 17px; font-weight: bold;">
                                <template #first>
                                    <b-form-select-option :value="null" disabled>-- YEAR --</b-form-select-option>
                                </template>
                            </b-form-select>
                        </div>

                        <div style="display: inline-block; vertical-align: top;" v-if="year">
                            <div>SELECT MONTH</div>

                            <b-form-select size="lg" :options="months" v-model="month" style="width: 180px; font-size: 17px; font-weight: bold;" v-on:change="get_dl_dates_for_year_month">
                                <template #first>
                                    <b-form-select-option :value="null" disabled>-- MONTH --</b-form-select-option>
                                </template>
                            </b-form-select>
                        </div>

                        <div style="display: inline-block; vertical-align: top;" v-if="year && month">
                            <div>SELECT DATE</div>

                            <b-form-select size="lg" :options="dates" v-model="picked_date" style="width: 180px; font-size: 17px; font-weight: bold;" v-on:change="get_dl_items_for_date">
                                <template #first>
                                    <b-form-select-option :value="null" disabled>-- DATE --</b-form-select-option>
                                </template>
                            </b-form-select>
                        </div>


                        <div style="display: inline-block; vertical-align: top;" v-if="items.length >0">
                            <div>FILTER LOCATION</div>

                            <b-form-select size="lg" :options="filter_locations(packet.locations)" v-model="picked_location_id" style="width: 220px; font-size: 17px; font-weight: bold;">
                                <template #first>
                                    <b-form-select-option :value="null" disabled>-- LOADING LOCATION --</b-form-select-option>
                                </template>
                            </b-form-select>
                        </div>

                    </div>
                </b-alert>
            </div>
        </div>

        <!-- <div style="width: 100%; max-height: 800px; overflow-y: scroll; padding: 5px; min-height: 200px;">
            <b-card no-body style=" min-height: 200px;">
                <div v-if="items_being_loaded">
                    <loading 
                    :active="true" 
                    :can-cancel="false" 
                    :is-full-page="false">
                    </loading>

                </div>

                <div v-else>
                    <div  v-if="items.length > 0" style="">
                        <table style="width: 100%; ">
                            <thead>
                                
                            </thead>

                            <tbody v-for="item,idx in items" v-bind:key="idx">
                                <tr v-if="item.items.length > 0">
                                    <td class="ipt_tdhr" style="font-size: 12px !important;">
                                        INVOICE #
                                    </td>

                                    <td class="ipt_tdhr">
                                        PRODUCT SKU
                                    </td>

                                    <td class="ipt_tdhr">
                                        QTY
                                    </td>

                                    <td class="ipt_tdhr">
                                        LOAD FROM
                                    </td>

                                    <td class="ipt_tdhr">
                                        TRUCK
                                    </td>

                                    <td class="ipt_tdhr">
                                        CURRENT STATE
                                    </td>

                                    <td class="ipt_tdhr">
                                        NEW STATE
                                    </td>

                                    <td class="ipt_tdhr hidden-print">
                                        ACTIONS
                                    </td>

                                </tr>
                                <tr v-for="element,eidx in item.items" v-bind:key="eidx" v-if="(element.truck == allowed_truck || allowed_truck == null)">
                                    <td class="ipt_tdr" :style="{background: colors_dict[element.invoice_id]}">
                                        {{ element.invoice_id }}
                                    </td>

                                    <td class="ipt_tdr" :style="{background: colors_dict[element.invoice_id]}">
                                        {{ element.product_sku }}
                                    </td>

                                    <td class="ipt_tdr" :style="{background: colors_dict[element.invoice_id]}">
                                        {{ element.quantity }}
                                    </td>

                                    <td class="ipt_tdr" :style="{background: colors_dict[element.invoice_id]}">
                                        {{ packet.locsubsdict[element.drop_locsub] }}
                                    </td>

                                    <td class="ipt_tdr" :style="{background: colors_dict[element.invoice_id]}">
                                        {{ (packet.trucksdict[element.truck] || '').toUpperCase() }}
                                    </td>

                                    <td class="ipt_tdr" :style="{background: colors_dict[element.invoice_id]}">
                                        {{ states_dict[element.state] }}
                                    </td>

                                    <td class="ipt_tdr" :style="{background: colors_dict[element.invoice_id]}">
                                        <b-form-select :options="states_to_dl" style="width: 160px; font-size: 13px;" @change="update_item(item,element)" v-model="element.new_state"></b-form-select>
                                    </td>

                                    <td class="ipt_tdr hidden-print" :style="{background: colors_dict[element.invoice_id]}">
                                        <button @click="show_comments(element)">COMMENTS</button>
                                    </td>
                                </tr>
                                <tr>
                                    <td style="visibility: hidden;">
                                        GAP
                                    </td>
                                </tr>
                            </tbody>
                        </table>


                    </div>
                </div>
            </b-card>
        </div> -->

        <div style="width: 100%; max-height: 800px; overflow-y: scroll; padding: 5px; min-height: 200px;">
            <b-card no-body style="min-height: 200px;">
                <div v-if="items_being_loaded == true">
                    <loading 
                    :active="true" 
                    :can-cancel="false" 
                    :is-full-page="false">
                    </loading>

                </div>

                <div v-else-if="items_being_loaded == false">
                    <div  v-if="items.length > 0" style="">
                        <table style="width: 100%;">
                            <thead>
                                <tr style="background: black; color: white; font-size: 14px; text-align: center;">
                                    <td @click="sortby('invoice_id')" style="border: 1px solid white;"> 
                                        INVOICE #
                                    </td>

                                    <td @click="sortby('product_name')" style="border: 1px solid white;">
                                        PRODUCT NAME
                                    </td>

                                    <td @click="sortby('product_sku')" style="border: 1px solid white;">
                                        PRODUCT SKU
                                    </td>

                                    <td style="border: 1px solid white;">
                                        QTY
                                    </td>


                                    <td @click="sortby('locsub')" style="border: 1px solid white;">
                                        CURRENT LOCATION
                                    </td>

                                    <td @click="sortby('drop_locsub')" style="border: 1px solid white;">
                                        LOAD FROM
                                    </td>

                                    <td @click="sortby('truck', packet.trucksdict)" style="border: 1px solid white;">
                                        TRUCK
                                    </td>

                                    <td style="border: 1px solid white; width: 150px;" @click="sortby('state')">
                                        STATUS
                                    </td>

                                    <td class="hidden-print" style="border: 1px solid white;">
                                        COMMENTS
                                    </td>
                                </tr>
                            </thead>

                            <tbody>
                                <tr style="background: white; font-size: 14px; text-align: center;" v-for="item,idx in items" v-bind:key="idx" v-if="allowed(item)">
                                    <td style="border: 1px solid black;"> 
                                        {{ item.invoice_id }}
                                    </td>

                                    <td style="border: 1px solid black;">
                                        {{ ( (item.product_name || item.product_sku) || '').toUpperCase() }}
                                    </td>

                                    <td style="border: 1px solid black;">
                                        {{ ( item.product_sku || '').toUpperCase() }}
                                    </td>

                                    <td style="border: 1px solid black;">
                                        {{ item.quantity }}
                                    </td>

                                    <td style="border: 1px solid black;">
                                        {{ packet.locsubsdict[item.locsub] }}
                                    </td>

                                    <td style="border: 1px solid black;">
                                        {{ packet.locsubsdict[item.drop_locsub] }}
                                    </td>

                                    <td style="border: 1px solid black;">
                                        {{ packet.trucksdict[item.truck] }}
                                    </td>

                                    <td style="border: 1px solid black;">
                                        <b-form-select size="sm" :style="{width: '150px', background: get_background(item)}" :options="states" v-model="item.state" v-on:change="update_invoice_item_state(item)"></b-form-select > 
                                    </td>

                                    <td class="ipt_tdr hidden-print" style="border: 1px solid black;">
                                        <button  @click="show_comments(ditem)">CMNT</button>
                                    </td> 
                                </tr>
                            </tbody>

                        </table>

                    </div>

                    <div v-else>
                        <b-alert show>NO ITEM FOUND</b-alert>
                    </div>
                </div>

                <div v-else>

                </div>
            </b-card>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import mappings from '@/utilities/mappings'
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import Requestor from '@/utilities/Requestor';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    import ItemComments from '@/components/importables/ItemComments'

    export default {
        name: "DeliveriesLoading",
        components: {flatPickr, Loading, ItemComments},
        data: function(){
            let out = {
                items: [],
                dates: [],
                active_date:null,
                packet: {},
                items_being_loaded: false,
                dates_being_loaded: false,
                current_date: null,
                locations: [],
                locsub: null,
                states: mappings.states.map(function(d){ if ([0,5,-5,10,-10,6,-6,].includes(d.value)){ d.disabled=false} else {d.disabled=true}; return d }),
                states_dict: mappings.states_dict,
                item_comments_invoice_id: null,
                item_comments_itemid: null,
                colors_dict: {},
                allowed_truck: null,
                allowed_locsub: null,
                locsubs: [],

                years: [
                    {value: 2021, text: 2021},
                    {value: 2022, text: 2022},
                    {value: 2023, text: 2023},
                    {value: 2024, text: 2024},
                    {value: 2025, text: 2025},
                    {value: 2026, text: 2026},
                    {value: 2027, text: 2027},
                    {value: 2028, text: 2028},
                    {value: 2029, text: 2029},
                    {value: 2030, text: 2030},
                    {value: 2031, text: 2031},
                    {value: 2032, text: 2032},
                    {value: 2033, text: 2033},
                    {value: 2034, text: 2034},
                    {value: 2035, text: 2035},
                ],
                months: [
                    {value: 1, text: 1},
                    {value: 2, text: 2},
                    {value: 3, text: 3},
                    {value: 4, text: 4},
                    {value: 5, text: 5},
                    {value: 6, text: 6},
                    {value: 7, text: 7},
                    {value: 8, text: 8},
                    {value: 9, text: 9},
                    {value: 10, text: 10},
                    {value: 11, text: 11},
                    {value: 12, text: 12},
                ],
                sort_asc: false,
                year: null, 
                month: null,
                picked_date: null,
                picked_location_id: null,
            }

            //out.states_to_dl = out.states.filter(function(d){return  [0,2,-2,10,-10].includes(d.value)});
            return out
        },
        methods: {
            get_background: function(item){
                let state = item.state;
                let bg = 'white';
                if (state == 10){
                    bg = 'lightgreen'
                }
                return bg

            },
            allowed: function(item){
                let is_main_warehouse = item.is_main_warehouse;
                let userrole = this.packet.userDetails.userrole;
                let status = true;
                if (this.picked_location_id == null) {
                    if (userrole == 'admin' || userrole == 'officeuser') {
                        status = true;
                    }
                    else {
                        if (item.is_main_warehouse == true){
                            status = true;
                        }
                        else {
                            status = false;
                        }
                    }
                }
                else {
                    if (item.pull_location_id == this.picked_location_id){
                        status = true
                    }
                    else {
                        status = false;
                    }
                }
                return status
            },
            get_dl_dates_for_year_month: function(){
                let path = "/api/sales/get_deliveries_loading_dates/"
                let that = this;
                let data = {year: this.year, month: this.month, merchandise_status: [1]};
                let s = function(response) {
                    if (response.data.result){
                        console.log(response.data.result)
                        that.dates = response.data.result;

                        that.dates = that.dates.map(function(d){
                            return {value: d.date, text: d.date + ' ('+d.n_invoices+')' }
                        });
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.dates_being_loaded = false;
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error retrieving dates for the loading items.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.dates_being_loaded = false;
                }

                this.items = []
                this.dates_being_loaded = true;
                this.picked_date = null;
                this.picked_location_id = null;
                Requestor.postSync(path, data, s, f);
            },
            get_dl_items_for_date: function(){
                let that = this;
                let path = "/api/sales/get_deliveries_loading/"
                let data = {date: this.picked_date, merchandise_status: [1]};

                let s = function(response) {
                    if (response.data.result){
                        that.items = response.data.result;
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false;
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error fetching loading items for the date.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false;
                }
                this.items = [];
                this.items_being_loaded = true;
                Requestor.postSync(path, data, s, f);
            },
            filter_locations: function(locations){
                let  userrole = this.packet.userDetails.userrole;
                if (userrole== 'admin' ||  userrole == 'officeuser'){
                    return locations
                }
                else{
                    //for everyone else including warehouseuser, officeuser, etc.
                    return locations.filter(function(d){ return d.is_main_warehouse == true})
                }  
            },
            get_bg: function(item){
                let all_items = item.items.length;
                let all_shipped = item.items.filter(function(d){
                    return d.state == 'shipped' || d.state == 'delivered'
                }).length;

                if (all_items ==  all_shipped){
                    return '#4caf50'
                }
                else {
                    return '#bf360c'
                }
            },
            update_item: function(item, element){
                let path = "/api/sales/update_invoice_item_state/"
                let that = this;
                
                let data = {invoice_id: element.invoice_id, itemid: element.itemid, state: element.state, changed_by: this.packet.userDetails.username}

                //console.log(data)
                //return
                let s = function(response) {
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        //item = response.data.result[0];
                        element.state = element.new_state;

                       
                        that.$bvToast.toast(
                            "Success updating item state.",
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                        
                    }
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error updating item state.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                }
                Requestor.postAsync(path, data, s, f);
            },
            toggle_details: function(item){
                item.show_details = (!item.show_details)
            },
            show_comments: function(item){
                this.item_comments_invoice_id = item.invoice_id;
                this.item_comments_itemid= item.itemid;

                this.$bvModal.show("modal-dl-comments");
            },
            update_invoice_item_state: function(item){
                let path = "/api/sales/update_invoice_item_state/"
                let that = this;
                
                let data = {invoice_id: item.invoice_id, itemid: item.itemid, state: item.state, changed_by: this.packet.userDetails.username}

                let s = function(response) {
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            "Success updating item state.",
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                        
                    }
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error updating item state.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                }
                Requestor.postAsync(path, data, s, f);
            },
            get_dates: function(){
                let path = "/api/sales/get_deliveries_loading_dates/"
                let that = this;
                let data = {locsub: this.locsub}
                let s = function(response) {
                    if (response.data.result){
                        that.dates = response.data.result;

                        that.dates = that.dates.map(function(d){
                            return {value: d.date, text: d.date + ' ('+d.nitems+')' }
                        });
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.dates_being_loaded = false;
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error retrieving dates for the loading items.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.dates_being_loaded = false;
                }

                this.items = []
                this.dates_being_loaded = true;
                this.active_date = null;
                Requestor.getSync(path, data, s, f);
            },
            get_items_for_date: function(date){

                this.active_date = date;
                
                let that = this;
                let path = "/api/sales/get_deliveries_loading/"
                
                let data = {locsub: this.locsub, date: date}


                let s = function(response) {
                    if (response.data.result){
                        that.items = response.data.result;

                        for (var i =0; i<that.items.length; i++){
                            let invoice_id = that.items[i].invoice_id;
                            let background = 'white';
                            if (i % 2 == 0){
                                background = '#e0e0e0';
                            }

                            that.colors_dict[invoice_id] = background;
                        }
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false;
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error fetching items for the date.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false;
                }
                this.items = [];
                this.allowed_truck = null;
                this.allowed_locsub = null;
                this.items_being_loaded = true;
                Requestor.getSync(path, data, s, f);

            },
            sortby: function(key,mapper){
                if (this.sort_asc){
                    this.items = Requestor.sort(this.items,key,mapper)
                }
                else {
                    this.items = Requestor.sort_reverse(this.items,key,mapper)
                }
                this.sort_asc = !this.sort_asc;
            },
            fetch_prereqs: function(){
            },
            fetch: function(){
                this.items = []
                this.dates = []
                this.active_date = null;
                this.locsub = null;
            },


        },
        created: function(){
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            let that = this;
            this.locsubs = this.packet.locsubs;
            this.locations = this.packet.locations.filter(function(d){
                return d.text.toLowerCase() != 'all'
            });

            if (that.packet.userDetails.userrole == "warehouseuser"){
                this.locsubs = this.packet.locsubs.filter(function(d){
                    return d.is_main_warehouse == true;
                }); 
                this.locsubs.splice(0, 0, {value: 'all', text: 'ALL'});
            }
            else {
                this.locsubs = this.packet.locsubs.filter(function(d){
                     if(that.packet.userDetails.userrole == "admin"){
                        return d
                    }
                    else {
                        return (that.packet.userDetails.properties || {}).location_id == +d.value.split("|")[0];
                    }
                });
                if(that.packet.userDetails.userrole == "admin"){
                    this.locsubs.splice(0, 0, {value: 'all', text: 'ALL'});
                }
            }

            
        }

    }

</script>

<style scoped>
    .ipt_tdr {
        font-family: roboto !important;
        font-size: 13px;
        background: white;
    }

    .pcol {
        padding: 5px;
    }

    .card-body {
        padding: 5px;
    }
</style>


// WEBPACK FOOTER //
// src/components/IncomingOutGoing/DeliveriesLoading.vue